import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CollectionEditor from "@/components/Collections/CollectionEditor";
import CollectionService from "@/services/CollectionService";
import InnerContainerLoader from "../InnerContainerLoader";

const EditCollection = () => {
  const { collectionId } = useParams();
  const [collection, setCollection] = useState(null);

  useEffect(() => {
    const fetchAndSetCollection = async () => {
      try {
        const data = await CollectionService.getCollectionById(collectionId);
        setCollection(data);
      } catch (error) {
        console.error("Error fetching collection:", error);
      }
    };

    fetchAndSetCollection();
  }, [collectionId]);

  if (!collection) {
    return (
      <div
        className="bg-grid relative isolate min-h-screen overflow-hidden text-fg"
      >
        <div className="relative mx-auto flex min-h-screen w-full max-w-5xl items-center justify-center px-4 py-24 sm:px-8 md:px-12">
          <InnerContainerLoader offset={0} />
        </div>
      </div>
    );
  }

  return <CollectionEditor collection={collection} />;
};

export default EditCollection;
